module.exports = __webpack_public_path__ + "static/media/feedback.381f8085.PNG";